import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from './services/user.service';
import { PhotoService } from './services/photo.service';
import { DraftService } from './services/draft.service';

@NgModule({
    imports: [CommonModule],
    providers: [DraftService, UserService, PhotoService]
})
export class DatalayerModule {}
